"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ViewSection;
    }
});
let ViewSection = class ViewSection {
    static async get(..._args) {
        return null;
    }
    static async list(..._args) {
        return [];
    }
    static async insert(..._args) {
        return null;
    }
    static async update(..._args) {
        return null;
    }
    static async delete(..._args) {
        return null;
    }
    static async findByTitle(..._args) {
        return null;
    }
    static async deleteByModelId(..._args) {
        return true;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
